var React = require('react');
var createReactClass = require('create-react-class');
var Helmet = require('react-helmet');
var PropTypes = require('prop-types');
var PureRenderMixin = require('react-addons-pure-render-mixin');
var cookie = require('react-cookie');
var JotformEmbed = require('react-jotform-embed').default;

var Generic = () => {
  return (
    <div>
      <h2>What's next</h2>    
      <p>If you answered yes to any of the symptom questions, check out MyGi.Health, developed by leading gastroenterologists just for you:</p>
      <ul>
          <li>Information on diseases</li>
          <li>Information on treatments</li>
          <li>Tools to track your symptoms</li>
          <li>Tools to find gastroenterologists in your area</li>
          <li>Tools to prepare for a visit with your gastroenterologist</li>
          <li>You can also register to be matched to clinical studies looking for participants like you!</li>
      </ul>
      <br />
      <p><a className="button large success" href="https://mygi.health/">Visit MyGiHealth</a></p>
    </div>
  )
}

var PlushCare = () => {
  return (
    <div>
      <h3>Talk to an experienced healthcare professional about your IBS-C or CIC from home.</h3>     
      <p>If your constipation, straining and abdominal symptoms keep returning, you could have a chronic condition, IBS-C (Irritable Bowel Syndrome with Constipation) or CIC (Chronic Idiopathic Constipation). Only a doctor can determine if you have IBS-C or CIC.</p>
      <p>Don’t wait to get the relief you deserve! Schedule a telemedicine appointment today or learn more at PlushCare.com.</p>
      <p><a className="button large success" href="https://book.plushcare.com/ibs-treatment?utm_medium=survey&utm_source=linzess&utm_campaign=linzess-survey">Visit PlushCare</a></p>
      <p>Remember, it’s important to tell the doctor about all of your symptoms along with:</p>
      <ul>
        <li>How long you’ve been experiencing them</li>
        <li>What you’ve done to manage them</li>
        <li>How they affect your personal and/or professional life</li>
      </ul>
    </div>
  )
}

var Gerd = () => {
  return (
    <div>
      <JotformEmbed src="https://form.jotformeu.com/201064765142146" />
    </div>
  )
}

var Home = createReactClass({
    mixins: [PureRenderMixin],   

  renderTemplate: (cta) => {
    switch(cta) {
      case 'gerd': 
        return <Gerd />;
      case 'plush':
        return <PlushCare />;
      default:
        return <Generic />;
    }
  },

    render: function(){
      const { responses = {} } = this.props;

      const iFrameStyle = {
          visibilty: 'hidden',
          width: 0,
          height: 0,
          border: 0
      }

      const { location } = this.props;

      // Use cta from reponses first, fall back to cta quertystring, which defaults to ''
      const { query: { cta: ctaQuery = '' } } = location;
      const { cta = ctaQuery } = responses;

      // Check for externalId cookie (CINT)
      // CINT link should have fixed ID for all users
      // const cintId = cookie.load('nhs_externalId') || 'fabd6577-0408-4b77-a2c2-4c9a6fe99b8f';         

      return (
			<div>
              <Helmet
                  title="National health survey"
                  meta={[{
                      name: 'description',
                      content: 'Nationwide health survey studying the prevalence of various diseases in the population as a whole.'
                  }]}
              />
			    <div id="hero-container">
			        <section id="hero">
			            <div className="row">
			                <div className="large-6 end small-12 column">
			                    <div id="headline">
                                    <h1>Thank you for taking the<br />National Health Survey.</h1>
			                    </div>
			                    <div>
                                    <h5>Your responses are anonymous but will help us understand key questions around how widespread some conditions are.</h5>
                                    <br />
                                    {this.renderTemplate(cta || 'Generic')}
                                    {(process.env.NODE_ENV === 'production') &&
                                    <iframe
                                        id="externalConfirmation"
                                        title="cINT-confirmation"
                                        style={iFrameStyle}
                                        src={'https://s.cint.com/Survey/Complete?ProjectToken=b1642df4-f9f9-4935-b2a5-3963aad80efc'}></iframe> }
			                    </div>
			                </div>

			            </div>
			        </section>
			    </div>
			</div>
      )
    }
});

Home.contextTypes = {
  router: PropTypes.object.isRequired
};

module.exports = Home;



// WEBPACK FOOTER //
// ./src/common/routes/survey/components/confirmation.jsx